import React, { Component } from 'react';
import "./Promo.scss";

export default class Promo extends Component {
    state = {}
    render() {
        return (
            <section className="section-promo">


            </section>

        );
    }
}




// WEBPACK FOOTER //
// ./src/Components/Promo/Promo.jsx